/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EloshieldModule } from './EloshieldModule';
import {
    EloshieldModuleFromJSON,
    EloshieldModuleFromJSONTyped,
    EloshieldModuleToJSON,
    EloshieldModuleToJSONTyped,
} from './EloshieldModule';

/**
 * 
 * @export
 * @interface ActionTemplateCreate
 */
export interface ActionTemplateCreate {
    /**
     * 
     * @type {string}
     * @memberof ActionTemplateCreate
     */
    label: string;
    /**
     * 
     * @type {any}
     * @memberof ActionTemplateCreate
     */
    nodes: any | null;
    /**
     * 
     * @type {any}
     * @memberof ActionTemplateCreate
     */
    edges: any | null;
    /**
     * 
     * @type {EloshieldModule}
     * @memberof ActionTemplateCreate
     */
    eloshieldModule: EloshieldModule;
}



/**
 * Check if a given object implements the ActionTemplateCreate interface.
 */
export function instanceOfActionTemplateCreate(value: object): value is ActionTemplateCreate {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('nodes' in value) || value['nodes'] === undefined) return false;
    if (!('edges' in value) || value['edges'] === undefined) return false;
    if (!('eloshieldModule' in value) || value['eloshieldModule'] === undefined) return false;
    return true;
}

export function ActionTemplateCreateFromJSON(json: any): ActionTemplateCreate {
    return ActionTemplateCreateFromJSONTyped(json, false);
}

export function ActionTemplateCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionTemplateCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'nodes': json['nodes'],
        'edges': json['edges'],
        'eloshieldModule': EloshieldModuleFromJSON(json['eloshieldModule']),
    };
}

export function ActionTemplateCreateToJSON(json: any): ActionTemplateCreate {
    return ActionTemplateCreateToJSONTyped(json, false);
}

export function ActionTemplateCreateToJSONTyped(value?: ActionTemplateCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'nodes': value['nodes'],
        'edges': value['edges'],
        'eloshieldModule': EloshieldModuleToJSON(value['eloshieldModule']),
    };
}

